export interface ClipPathConfig {
  width: number;
  height: number;
  clipPath: string;
}

export type ClipPathConfigs = Record<string, ClipPathConfig>;

export const clipPaths: ClipPathConfigs = {
  halfPill: {
    width: 160,
    height: 160,
    clipPath:
      'M10.7998 80.0002C10.7998 41.782 41.7818 10.8 80 10.8H107.2C130.396 10.8 149.2 29.6041 149.2 52.8V107.2C149.2 130.396 130.396 149.2 107.2 149.2H80C41.7818 149.2 10.7998 118.218 10.7998 80.0002Z'
  },
  oval: {
    width: 160,
    height: 160,
    clipPath:
      'M91.2 11.2C129.197 11.2 160 42.0028 160 80C160 117.997 129.197 148.8 91.2 148.8H68.8C30.8028 148.8 -1.66091e-06 117.997 0 80C1.66091e-06 42.0028 30.8028 11.1999 68.8 11.2L91.2 11.2Z'
  },
  clover: {
    width: 160,
    height: 160,
    clipPath:
      'M129.614 37.8248C126.121 36.6612 123.339 33.8787 122.175 30.3864C116.293 12.7301 99.633 0 80 0C60.367 0 43.7072 12.7301 37.8248 30.3864C36.6612 33.8787 33.8787 36.6612 30.3864 37.8248C12.7301 43.7073 0 60.367 0 80C0 99.633 12.7301 116.293 30.3864 122.175C33.8787 123.339 36.6612 126.121 37.8248 129.614C43.7073 147.27 60.367 160 80 160C99.633 160 116.293 147.27 122.175 129.614C123.339 126.121 126.121 123.339 129.614 122.175C147.27 116.293 160 99.633 160 80C160 60.367 147.27 43.7073 129.614 37.8248Z'
  },
  hexagon: {
    width: 160,
    height: 160,
    clipPath:
      'M59.5451 5.6971C72.3389 -1.89903 87.6615 -1.89904 100.455 5.69709L137.317 27.5831C146.843 33.2392 152.8 44.3288 152.8 56.4069V103.593C152.8 115.671 146.843 126.761 137.317 132.417L100.455 154.303C87.6615 161.899 72.3389 161.899 59.5451 154.303L22.6835 132.417C13.1572 126.761 7.2002 115.671 7.2002 103.593V56.4069C7.2002 44.3288 13.1572 33.2392 22.6835 27.5831L59.5451 5.6971Z'
  },
  triangle: {
    width: 160,
    height: 160,
    clipPath:
      'M125.027 39.6253C140.332 47.2338 150 62.7867 150 79.7999C150 96.8131 140.332 112.366 125.027 119.975L75.7785 144.458C69.5056 147.576 62.5887 149.2 55.5754 149.2C30.6257 149.2 10.3999 129.09 10.3999 104.283L10.3999 55.3165C10.3999 30.5098 30.6257 10.3999 55.5754 10.3999C62.5887 10.3999 69.5057 12.0234 75.7785 15.1419L125.027 39.6253Z'
  }
};
